import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ISceneFilmstripProps } from '@/@types/sceneEditorV2';

function SceneFilmstrip({
  scenes,
  selectedIndex,
  onSelectScene,
  thumbnailUrls,
}: ISceneFilmstripProps) {
  return (
    <div className="flex items-center gap-2 border-t border-border px-4 py-2">
      {/* Scene thumbnails */}
      <div className="flex items-center gap-1.5 overflow-x-auto">
        {scenes.map((scene, index) => (
          <button
            key={scene._id}
            onClick={() => onSelectScene(index)}
            className={cn(
              'relative h-[76px] w-[130px] flex-shrink-0 overflow-hidden rounded',
              index === selectedIndex
                ? 'border-2 border-primary'
                : 'border border-border hover:border-foreground-muted'
            )}
          >
            {thumbnailUrls.get(scene._id) ? (
              <img
                src={thumbnailUrls.get(scene._id)}
                alt={`Scene ${index + 1}`}
                className="h-full w-full object-cover"
              />
            ) : (
              <div className="flex h-full w-full items-center justify-center bg-background-secondary" />
            )}
            {/* Scene number badge */}
            <span className="absolute bottom-1 left-1 flex size-5 items-center justify-center rounded-full bg-black/60 text-xs font-medium text-white">
              {index + 1}
            </span>
          </button>
        ))}
      </div>

      {/* Add scene button */}
      <button className="flex h-[76px] w-[76px] flex-shrink-0 items-center justify-center rounded border border-dashed border-border hover:border-primary">
        <Plus size={18} className="text-foreground-muted" />
      </button>
    </div>
  );
}

export { SceneFilmstrip };
